import { useEffect } from "react";
import { useSearchParams } from 'react-router-dom';


function StripeAddAccountFailed() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    try {
      const body = document.querySelector("body");
      body.classList.add("no-header", "no-footer");
    } catch (err) {
      console.error(err);
    }
  }, []);
  function handleGoToApp(event){
    event.preventDefault();
    const appData = { action: 'stripe-add-account-failed', data: {}};
    window.ReactNativeWebView?.postMessage(JSON.stringify(appData));
  }
  return (
    <main>
      <section className="privacy-policy banner-scetion-padding py-5">
        <div className="container">
          <h1 className="heading-1" style={{fontSize: '40px', lineHeight: '40px'}}>Failed</h1>
        </div>
      </section>
      <section className="d-block">
        <div className="container">
          <div className="time-update mb-4 text-center">
            <div className="action-animation my-4">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                <circle className="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                <line className="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
                <line className="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
              </svg>
              <p className="error mb-0">Oh No!</p>
            </div>
            <h2 style={{fontSize: '28px', lineHeight: '30px'}}>Oops, Something went wrong, please try again later.</h2>
            <a href="/" onClick={handleGoToApp} className="btn btn-black mt-4">Go to app</a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default StripeAddAccountFailed;
